import { Box, Center, Spinner } from "@chakra-ui/react"


import { setBackForwardNavigationGestures } from "capacitor-plugin-ios-webview-configurator"
import { useEffect } from "react"




const LoadingPage = () => {

    useEffect(() => {
        setBackForwardNavigationGestures(false)
    }, [])

    return <Center h='90vh'>
        <Box>
            <Box 
                bgImage='/logo_black.svg' 
                w='80px' h='33px' 
                bgPos='center' bgSize='contain'
                bgRepeat='no-repeat'
                mb='12px'
                userSelect="none" // Prevent selection of the logo
            />
            <Center mr='8px'>
                <Spinner size='sm' color='#171C22' />
            </Center>
        </Box>
    </Center>
}


export default LoadingPage